// extracted by mini-css-extract-plugin
module.exports = {"subSection":"EditListingDescriptionPageEight_subSection__oBS6B","subSectionPrimary":"EditListingDescriptionPageEight_subSectionPrimary__3AIXC"};